(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

      /* Collection Pagination */
      this.initPagination();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Facet helpers (categories, price bands, future brands) */

    FACET_JOINER: '+',
    PRICE_BANDS_KEY: 'price_bands',
    BRANDS_KEY: 'brands',
    VENDOR_FILTER_KEY: 'filter.p.vendor',

    /* Controle de facet no sidebar. Os botões "Limpar" moram na mesma seção e
       também são <button>, por isso ficam de fora. */
    FACET_CONTROL: 'button:not(.clear):not(.filter-clear)',

    parseFacetList: function(value, joiner) {
      joiner = joiner || collection.FACET_JOINER;
      if (!value || typeof value !== 'string') {
        return [];
      }
      return value.split(joiner).map(function(item) {
        return item.trim();
      }).filter(Boolean);
    },

    serializeFacetList: function(list, joiner) {
      joiner = joiner || collection.FACET_JOINER;
      if (!list || !list.length) {
        return '';
      }
      return list.join(joiner);
    },

    toggleFacetValue: function(list, value) {
      var values = Array.isArray(list) ? list.slice() : collection.parseFacetList(list);
      var pos = values.indexOf(value);
      if (pos >= 0) {
        values.splice(pos, 1);
      } else {
        values.push(value);
      }
      return values;
    },

    setQueryFacetParam: function(paramKey, values) {
      var list = Array.isArray(values) ? values.filter(Boolean) : collection.parseFacetList(values);
      if (list.length) {
        Shopify.queryParams[paramKey] = collection.serializeFacetList(list);
      } else {
        delete Shopify.queryParams[paramKey];
      }
    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    isValidCollectionHandle: function(handle) {
      return typeof handle === 'string' && /^[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/.test(handle);
    },

    isAllowedCategoryHandle: function(handle) {
      if (!collection.isValidCollectionHandle(handle)) {
        return false;
      }

      var isAllowed = false;
      $('.filter-collection button[data-collection-handle]').each(function() {
        if ($(this).attr('data-collection-handle') === handle) {
          isAllowed = true;
          return false;
        }
      });
      return isAllowed;
    },

    getSubcollectionHandles: function() {
      var handles = collection.parseFacetList(Shopify.queryParams.subcollection);
      var allowed = [];

      handles.forEach(function(handle) {
        if (collection.isAllowedCategoryHandle(handle) && allowed.indexOf(handle) === -1) {
          allowed.push(handle);
        }
      });

      collection.setQueryFacetParam('subcollection', allowed);
      return allowed;
    },

    sanitizeSubcollectionParam: function() {
      return collection.serializeFacetList(collection.getSubcollectionHandles());
    },

    filterCategories: function() {
      collection.syncCategoryFilterUI();

      $("body").delegate('.filter-collection ' + collection.FACET_CONTROL, 'click', function(e) {
        e.preventDefault();

        var $link = $(this);
        var handle = String($link.attr('data-collection-handle') || '');

        if (!collection.isValidCollectionHandle(handle) || !collection.isAllowedCategoryHandle(handle)) {
          return;
        }

        var handles = collection.getSubcollectionHandles();
        handles = collection.toggleFacetValue(handles, handle);
        collection.setQueryFacetParam('subcollection', handles);
        collection.syncCategoryFilterUI();
        collection.syncSidebarUiState();
        collection.filterAjaxClick();
      });
    },

    syncCategoryFilterUI: function() {
      var activeHandles = collection.getSubcollectionHandles();

      $('.filter-collection').each(function() {
        var $filter = $(this);
        $filter.find(collection.FACET_CONTROL).removeClass('active');
        $filter.find('input[type="checkbox"]').prop('checked', false);

        if (activeHandles.length) {
          $filter.find('button[data-collection-handle]').each(function() {
            var $link = $(this);
            if (activeHandles.indexOf($link.attr('data-collection-handle')) !== -1) {
              $link.addClass('active');
              $link.prev('input[type="checkbox"]').prop('checked', true);
            }
          });
        }
      });
    },

    clearCategoryFilterUI: function() {
      $('.filter-collection ' + collection.FACET_CONTROL).removeClass('active');
      $('.filter-collection input[type="checkbox"]').prop('checked', false);
    },

    getCategoryParentPath: function() {
      var $filterCollection = $('.filter-collection').first();
      var parentUrl = $filterCollection.length ? $filterCollection.data('parent-url') : location.pathname;
      return String(parentUrl || location.pathname).split('?')[0].replace(/\/$/, '');
    },

    getCategoryFetchUrls: function(newurl) {
      var urlToParse = newurl || collection.filterCreateUrl();
      var urlParts = urlToParse.split('?');
      var params = collection.parseQueryString(urlParts[1] || '');
      var subHandles = collection.parseFacetList(params.subcollection || Shopify.queryParams.subcollection);
      var fetchParams = $.extend({}, params);
      delete fetchParams.subcollection;

      // traditional: true → arrays viram chaves repetidas (sem []), formato OR da Shopify
      var query = $.param(fetchParams, true).replace(/%2B/g, '+');
      var querySuffix = query ? '?' + query : '';
      var allowedHandles = [];

      subHandles.forEach(function(handle) {
        if (collection.isAllowedCategoryHandle(handle) && allowedHandles.indexOf(handle) === -1) {
          allowedHandles.push(handle);
        }
      });

      if (!allowedHandles.length) {
        return [urlParts[0] + querySuffix];
      }

      if (allowedHandles.length === 1) {
        return ['/collections/' + encodeURIComponent(allowedHandles[0]) + querySuffix];
      }

      // v2: merge page N from each subcollection; pagination is picked and rewritten after merge
      return allowedHandles.map(function(handle) {
        return '/collections/' + encodeURIComponent(handle) + querySuffix;
      });
    },

    getCategoryFetchUrl: function(newurl) {
      var urls = collection.getCategoryFetchUrls(newurl);
      return urls[0];
    },

    pickBestPagination: function(responses) {
      var bestPagination = null;
      var bestMaxPage = -1;

      if (!Array.isArray(responses)) {
        return bestPagination;
      }

      responses.forEach(function(html) {
        var $pagination = $(html).find('.pagination').first();
        if (!$pagination.length) {
          return;
        }

        var maxPage = 0;
        $pagination.find('.pagination-link').each(function() {
          var pageText = parseInt($(this).text().trim(), 10);
          if (!isNaN(pageText) && pageText > maxPage) {
            maxPage = pageText;
          }

          var href = $(this).attr('href') || '';
          var pageMatch = href.match(/[?&]page=(\d+)/);
          if (pageMatch) {
            var pageFromHref = parseInt(pageMatch[1], 10);
            if (!isNaN(pageFromHref) && pageFromHref > maxPage) {
              maxPage = pageFromHref;
            }
          }
        });

        if (maxPage > bestMaxPage) {
          bestMaxPage = maxPage;
          bestPagination = $pagination;
        }
      });

      return bestPagination;
    },

    applyMergedPagination: function(responses) {
      var $bestPagination = collection.pickBestPagination(responses);
      var $container = $('.card-pagination').first();

      if (!$bestPagination || !$bestPagination.length) {
        if ($container.length) {
          $container.hide();
        }
        $('.pagination').hide();
        return;
      }

      var $paginationClone = $bestPagination.clone();

      if ($container.length) {
        var $existingPagination = $container.find('.pagination');
        if ($existingPagination.length) {
          $existingPagination.replaceWith($paginationClone);
        } else {
          $container.append($paginationClone);
        }
        $container.show();
        return;
      }

      var $grid = $('.grid-uniform').first();
      if ($grid.length) {
        $grid.append($('<div class="card-pagination"></div>').append($paginationClone));
      }
    },

    rewritePaginationLinks: function() {
      var subHandles = collection.getSubcollectionHandles();
      if (!subHandles.length) {
        return;
      }

      var parentPath = collection.getCategoryParentPath();
      var subValue = subHandles.join(collection.FACET_JOINER);

      $('.pagination a.pagination-link[href]').each(function() {
        var href = $(this).attr('href');
        if (!href || href === '#') {
          return;
        }

        var hrefParts = href.split('?');
        var params = collection.parseQueryString(hrefParts[1] || '');
        params.subcollection = subValue;

        var newQuery = $.param(params, true).replace(/%2B/g, '+');
        $(this).attr('href', parentPath + (newQuery ? '?' + newQuery : ''));
      });
    },

    updateDocumentSeo: function(html) {
      if (!html || typeof html !== 'string') {
        return;
      }

      var doc;
      try {
        doc = new DOMParser().parseFromString(html, 'text/html');
      } catch (err) {
        return;
      }

      if (!doc) {
        return;
      }

      if (doc.title) {
        document.title = doc.title;
      }

      var syncMetaByName = function(name) {
        var incoming = doc.querySelector('meta[name="' + name + '"]');
        if (!incoming) {
          return;
        }
        var current = document.querySelector('meta[name="' + name + '"]');
        var content = incoming.getAttribute('content') || '';
        if (current) {
          current.setAttribute('content', content);
        } else if (content) {
          var meta = document.createElement('meta');
          meta.setAttribute('name', name);
          meta.setAttribute('content', content);
          document.head.appendChild(meta);
        }
      };

      var syncMetaByProperty = function(property) {
        var incoming = doc.querySelector('meta[property="' + property + '"]');
        if (!incoming) {
          return;
        }
        var current = document.querySelector('meta[property="' + property + '"]');
        var content = incoming.getAttribute('content') || '';
        if (current) {
          current.setAttribute('content', content);
        }
      };

      syncMetaByName('description');
      syncMetaByName('robots');
      syncMetaByProperty('og:title');
      syncMetaByProperty('og:description');
      syncMetaByProperty('og:url');

      var incomingCanonical = doc.querySelector('link[rel="canonical"]');
      var currentCanonical = document.querySelector('link[rel="canonical"]');
      if (incomingCanonical && currentCanonical) {
        currentCanonical.setAttribute('href', incomingCanonical.getAttribute('href') || '');
      }

      var $doc = $(doc);
      var $incomingTitle = $doc.find('.title-page h1, .title-page h2').first();
      var $currentTitle = $('.title-page h1, .title-page h2').first();
      if ($incomingTitle.length && $currentTitle.length) {
        $currentTitle.text($incomingTitle.text());
      }

      var $incomingDescription = $doc.find('.collection-description-content .description-text').first();
      var $currentDescription = $('.collection-description-content .description-text').first();
      if ($incomingDescription.length && $currentDescription.length) {
        $currentDescription.html($incomingDescription.html());
      }
    },

    getProductDedupeKey: function($item) {
      return $item.attr('data-product-handle')
        || $item.find('[data-product-id]').first().attr('data-product-id')
        || $item.find('a.engoj_btn_quickview').attr('data-id')
        || '';
    },

    getProductsPerPage: function() {
      var perPage = 48;
      var metaEl = document.getElementById('collection-oos-meta');

      if (metaEl) {
        try {
          var meta = JSON.parse(metaEl.textContent || '{}');
          var metaPerPage = parseInt(meta.perPage, 10);
          if (!isNaN(metaPerPage) && metaPerPage > 0) {
            perPage = metaPerPage;
          }
        } catch (err) {
          // Keep default 48
        }
      }

      return perPage;
    },

    buildMergedProductGrid: function(responses) {
      var seenIds = {};
      var $mergedRow = $('<div class="row"></div>');
      var hasProducts = false;
      var maxProducts = collection.getProductsPerPage();
      var addedCount = 0;
      var reachedLimit = false;

      responses.forEach(function(html) {
        if (reachedLimit) {
          return;
        }

        $(html).find('.grid-uniform .row').children().each(function() {
          if (addedCount >= maxProducts) {
            reachedLimit = true;
            return false;
          }

          var $item = $(this);

          if ($item.find('[data-product-id], [data-product-handle]').length === 0 && $item.find('.text-center').length) {
            return;
          }

          var productKey = collection.getProductDedupeKey($item);
          if (!productKey || seenIds[productKey]) {
            return;
          }

          seenIds[productKey] = true;
          hasProducts = true;
          addedCount += 1;
          $mergedRow.append($item.clone());
        });
      });

      if (!hasProducts) {
        $mergedRow.append(
          '<div class="text-center col-12"><p>' + (window.collectionNoMatchesText || 'No products found') + '</p></div>'
        );
      }

      var $existingGrid = $('.grid-uniform').first();
      var $newGrid;

      if ($existingGrid.length) {
        $newGrid = $existingGrid.clone();
        $newGrid.find('.row').replaceWith($mergedRow);
      } else {
        $newGrid = $('<div class="product-grid-view grid-uniform"></div>').append($mergedRow);
      }

      return $newGrid;
    },

    sanitizePriceBand: function(band) {
      if (typeof band !== 'string') {
        return '';
      }

      var parts = band.split('-');
      if (parts.length !== 2) {
        return '';
      }

      var min = parseFloat(parts[0]);
      var max = parseFloat(parts[1]);

      if (!Number.isFinite(min) || !Number.isFinite(max) || min > max) {
        return '';
      }

      return String(min) + '-' + String(max);
    },

    getPriceBands: function() {
      var bands = collection.parseFacetList(Shopify.queryParams[collection.PRICE_BANDS_KEY]);
      var allowed = [];

      bands.forEach(function(band) {
        var sanitized = collection.sanitizePriceBand(band);
        if (sanitized && allowed.indexOf(sanitized) === -1) {
          allowed.push(sanitized);
        }
      });

      collection.setQueryFacetParam(collection.PRICE_BANDS_KEY, allowed);
      return allowed;
    },

    bandFromPriceLink: function($link) {
      var min = $link.data('min');
      var max = $link.data('max');

      if (min == null || max == null) {
        return '';
      }

      return collection.sanitizePriceBand(String(min) + '-' + String(max));
    },

    applyPriceBandsToQuery: function(bands) {
      var priceGteKey = 'filter.v.price.gte';
      var priceLteKey = 'filter.v.price.lte';

      if (!bands || !bands.length) {
        delete Shopify.queryParams[priceGteKey];
        delete Shopify.queryParams[priceLteKey];
        delete Shopify.queryParams[collection.PRICE_BANDS_KEY];
        return;
      }

      var minVal = null;
      var maxVal = null;

      bands.forEach(function(band) {
        var parts = band.split('-');
        var min = parseFloat(parts[0]);
        var max = parseFloat(parts[1]);

        if (minVal === null || min < minVal) {
          minVal = min;
        }
        if (maxVal === null || max > maxVal) {
          maxVal = max;
        }
      });

      collection.setQueryFacetParam(collection.PRICE_BANDS_KEY, bands);
      Shopify.queryParams[priceGteKey] = String(minVal);
      Shopify.queryParams[priceLteKey] = String(maxVal);
    },

    syncLegacyPriceBandsFromQuery: function() {
      if (Shopify.queryParams[collection.PRICE_BANDS_KEY]) {
        return;
      }

      var gte = Shopify.queryParams['filter.v.price.gte'];
      var lte = Shopify.queryParams['filter.v.price.lte'];

      if (!gte || !lte) {
        return;
      }

      var matchedBands = [];

      $('.filter-price ' + collection.FACET_CONTROL).each(function() {
        var band = collection.bandFromPriceLink($(this));
        if (!band) {
          return;
        }

        var parts = band.split('-');
        if (String(parts[0]) === String(gte) && String(parts[1]) === String(lte)) {
          matchedBands.push(band);
        }
      });

      if (matchedBands.length) {
        collection.applyPriceBandsToQuery(matchedBands);
      }
    },

    fillterPriceEvents: function() {
      collection.syncPriceFilterUI();

      $("body").delegate('.filter-price ' + collection.FACET_CONTROL, 'click', function(e) {
        e.preventDefault();

        var $link = $(this);
        var band = collection.bandFromPriceLink($link);

        if (!band) {
          return;
        }

        var bands = collection.getPriceBands();
        bands = collection.toggleFacetValue(bands, band);
        collection.applyPriceBandsToQuery(bands);
        collection.syncPriceFilterUI();
        collection.syncSidebarUiState();
        /* Após AJAX de preço, a resposta Liquid recalcula faixas no range já
           filtrado. Trocar o DOM + sanitize removeria a faixa ativa e dispararia
           um 2º AJAX sem filtro. Preservar as faixas do DOM atual. */
        collection.filterAjaxClick(null, { preservePriceBands: true });
      });
    },

    syncPriceFilterUI: function() {
      var bands = collection.getPriceBands();

      $('.filter-price').each(function() {
        var $filter = $(this);
        $filter.find(collection.FACET_CONTROL).removeClass('active');
        $filter.find('input[type="checkbox"]').prop('checked', false);

        if (bands.length) {
          $filter.find(collection.FACET_CONTROL).each(function() {
            var $link = $(this);
            var band = collection.bandFromPriceLink($link);

            if (bands.indexOf(band) !== -1) {
              $link.addClass('active');
              $link.prev('input[type="checkbox"]').prop('checked', true);
            }
          });
        }
      });
    },

    clearPriceFilterParams: function() {
      delete Shopify.queryParams['filter.v.price.gte'];
      delete Shopify.queryParams['filter.v.price.lte'];
      delete Shopify.queryParams[collection.PRICE_BANDS_KEY];
    },

    parseBrandsParam: function(value) {
      if (!value || typeof value !== 'string') {
        return [];
      }

      return value.split(collection.FACET_JOINER).map(function(item) {
        try {
          return decodeURIComponent(item.trim());
        } catch (err) {
          return item.trim();
        }
      }).filter(Boolean);
    },

    serializeBrandsParam: function(list) {
      if (!list || !list.length) {
        return '';
      }

      return list.map(function(vendor) {
        return encodeURIComponent(vendor);
      }).join(collection.FACET_JOINER);
    },

    isAllowedBrand: function(vendor) {
      if (!vendor) {
        return false;
      }

      var isAllowed = false;
      $('.filter-vendor button[data-vendor]').each(function() {
        if ($(this).attr('data-vendor') === vendor) {
          isAllowed = true;
          return false;
        }
      });
      return isAllowed;
    },

    getBrands: function() {
      var brands = collection.parseBrandsParam(Shopify.queryParams[collection.BRANDS_KEY]);
      var allowed = [];

      brands.forEach(function(vendor) {
        if (collection.isAllowedBrand(vendor) && allowed.indexOf(vendor) === -1) {
          allowed.push(vendor);
        }
      });

      if (allowed.length) {
        Shopify.queryParams[collection.BRANDS_KEY] = collection.serializeBrandsParam(allowed);
      } else {
        delete Shopify.queryParams[collection.BRANDS_KEY];
      }

      return allowed;
    },

    applyBrandsToQuery: function(brands) {
      if (!brands || !brands.length) {
        delete Shopify.queryParams[collection.BRANDS_KEY];
        delete Shopify.queryParams[collection.VENDOR_FILTER_KEY];
        return;
      }

      var allowed = brands.filter(Boolean);
      Shopify.queryParams[collection.BRANDS_KEY] = collection.serializeBrandsParam(allowed);
      // Array + $.param(..., true) → filter.p.vendor=A&filter.p.vendor=B (OR nativo)
      Shopify.queryParams[collection.VENDOR_FILTER_KEY] = allowed.slice();
    },

    syncLegacyBrandsFromQuery: function() {
      if (Shopify.queryParams[collection.BRANDS_KEY]) {
        return;
      }

      var vendorParam = Shopify.queryParams[collection.VENDOR_FILTER_KEY];
      if (!vendorParam) {
        return;
      }

      var brands = [];
      if (Array.isArray(vendorParam)) {
        brands = vendorParam.map(function(item) {
          return String(item).trim();
        }).filter(Boolean);
      } else if (typeof vendorParam === 'string') {
        // Legacy comma-joined URLs still supported
        brands = vendorParam.split(',').map(function(item) {
          return item.trim();
        }).filter(Boolean);
      }

      if (brands.length) {
        collection.applyBrandsToQuery(brands);
      }
    },

    filterBrands: function() {
      collection.syncBrandFilterUI();

      $("body").delegate('.filter-vendor ' + collection.FACET_CONTROL, 'click', function(e) {
        e.preventDefault();

        var $link = $(this);
        var vendor = String($link.attr('data-vendor') || '');

        if (!collection.isAllowedBrand(vendor)) {
          return;
        }

        var brands = collection.getBrands();
        brands = collection.toggleFacetValue(brands, vendor);
        collection.applyBrandsToQuery(brands);
        collection.syncBrandFilterUI();
        collection.syncSidebarUiState();
        collection.filterAjaxClick();
      });
    },

    syncBrandFilterUI: function() {
      var activeBrands = collection.getBrands();

      $('.filter-vendor').each(function() {
        var $filter = $(this);
        $filter.find(collection.FACET_CONTROL).removeClass('active');
        $filter.find('input[type="checkbox"]').prop('checked', false);

        if (activeBrands.length) {
          $filter.find('button[data-vendor]').each(function() {
            var $link = $(this);
            if (activeBrands.indexOf($link.attr('data-vendor')) !== -1) {
              $link.addClass('active');
              $link.prev('input[type="checkbox"]').prop('checked', true);
            }
          });
        }
      });
    },

    clearBrandFilterParams: function() {
      delete Shopify.queryParams[collection.BRANDS_KEY];
      delete Shopify.queryParams[collection.VENDOR_FILTER_KEY];
    },

    clearBrandFilterUI: function() {
      $('.filter-vendor ' + collection.FACET_CONTROL).removeClass('active');
      $('.filter-vendor input[type="checkbox"]').prop('checked', false);
    },

    hasActiveBrandFilters: function() {
      return !!(
        Shopify.queryParams[collection.BRANDS_KEY] ||
        Shopify.queryParams[collection.VENDOR_FILTER_KEY]
      );
    },

    fillterTagEvents: function() {

      $( "body" ).delegate( '.filter-tag:not(.filter-price) ' + collection.FACET_CONTROL + ', .filter-tag:not(.filter-price) label', 'click',function(e) {
         $(this).toggleClass('active');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.syncSidebarUiState();
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    hasActivePriceFilters: function() {
      return !!(
        Shopify.queryParams[collection.PRICE_BANDS_KEY] ||
        Shopify.queryParams['filter.v.price.gte'] ||
        Shopify.queryParams['filter.v.price.lte']
      );
    },

    hasActiveCategoryFilters: function() {
      return !!Shopify.queryParams.subcollection;
    },

    hasActiveTagFiltersInSection: function($section) {
      var currentTags = [];

      if (Shopify.queryParams.constraint) {
        currentTags = Shopify.queryParams.constraint.split('+');
      }

      var hasActive = false;
      $section.find('input[type="checkbox"]').each(function() {
        var tagName = $(this).val();
        if (tagName && currentTags.indexOf(tagName) !== -1) {
          hasActive = true;
          return false;
        }
      });

      return hasActive;
    },

    syncSidebarUiState: function() {
      $('.filter-price .filter-clear').toggleClass('is-visible', collection.hasActivePriceFilters());
      $('.filter-collection .filter-clear').toggleClass('is-visible', collection.hasActiveCategoryFilters());
      $('.filter-vendor .filter-clear').toggleClass('is-visible', collection.hasActiveBrandFilters());

      $('.filter-tag.filter-size, .filter-tag.filter-color, .filter-color.filter-tag').each(function() {
        var $section = $(this);
        $section.find('.filter-clear').toggleClass('is-visible', collection.hasActiveTagFiltersInSection($section));
      });

      /* Único ponto por onde passam todas as trocas de estado dos facets, então
         é aqui que aria-pressed acompanha a classe .active. */
      $('.engoj-collection-sidebar').find(collection.FACET_CONTROL).each(function() {
        $(this).attr('aria-pressed', $(this).hasClass('active') ? 'true' : 'false');
      });
    },

    clearSectionFilters: function($section) {
      if ($section.hasClass('filter-price')) {
        collection.clearPriceFilterParams();
        collection.syncPriceFilterUI();
        collection.syncSidebarUiState();
        collection.filterAjaxClick();
        return;
      }

      if ($section.hasClass('filter-collection')) {
        delete Shopify.queryParams.subcollection;
        collection.clearCategoryFilterUI();
        collection.syncSidebarUiState();
        collection.filterAjaxClick(collection.getCategoryParentPath());
        return;
      }

      if ($section.hasClass('filter-vendor')) {
        collection.clearBrandFilterParams();
        collection.clearBrandFilterUI();
        collection.syncSidebarUiState();
        collection.filterAjaxClick();
        return;
      }

      var currentTags = [];
      if (Shopify.queryParams.constraint) {
        currentTags = Shopify.queryParams.constraint.split('+');
      }

      $section.find('input:checked').each(function() {
        var tagName = $(this).val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          }
        }
      });

      $section.find(collection.FACET_CONTROL).removeClass('active');
      $section.find('input:checked').prop('checked', false);

      if (currentTags.length) {
        Shopify.queryParams.constraint = currentTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }

      collection.syncSidebarUiState();
      collection.filterAjaxClick();
    },

    filterMapClearAll: function() {
      $("body").delegate('.engoj-collection-sidebar .filter-clear', 'click', function(e) {
        e.preventDefault();
        var $section = $(this).closest('.filter-price, .filter-collection, .filter-vendor, .filter-tag');
        if (!$section.length) {
          return;
        }
        collection.clearSectionFilters($section);
      });

      $("body").delegate('.filter-block .clear', 'click', function(e) {
        e.preventDefault();
        var $section = $(this).closest('.filter-price, .filter-collection, .filter-vendor, .filter-tag');
        if ($section.length) {
          collection.clearSectionFilters($section);
        }
      });

      collection.syncSidebarUiState();
    },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    
    filterMapClear: function() {
      collection.syncSidebarUiState();
    }, 
    

    filterParams: function() {
        Shopify.queryParams = collection.parseQueryString(location.search.substr(1));
        collection.sanitizeSubcollectionParam();
        collection.getPriceBands();
        collection.applyPriceBandsToQuery(collection.getPriceBands());
        collection.syncLegacyBrandsFromQuery();
        collection.getBrands();
        collection.applyBrandsToQuery(collection.getBrands());
    },

    filterMapEvents: function() {
        collection.fillterPriceEvents();
        collection.fillterTagEvents();
        collection.filterCategories();
        collection.filterBrands();
    },

    resetFilter: function() {
        $(".filter-custom .active").removeClass("active");
        $(".filter-tag input:checked").prop("checked", false);
        $('.filter-tag ' + collection.FACET_CONTROL).removeClass("active");
        collection.syncPriceFilterUI();
        collection.syncCategoryFilterUI();
        collection.syncBrandFilterUI();
        collection.syncSidebarUiState();
    },

    getValidPriceBandsFromDom: function() {
      var validBands = [];

      $('.filter-price ' + collection.FACET_CONTROL).each(function() {
        var band = collection.bandFromPriceLink($(this));
        if (band && validBands.indexOf(band) === -1) {
          validBands.push(band);
        }
      });

      return validBands;
    },

    sanitizePriceBandsAgainstDom: function(options) {
      options = options || {};
      var validBands = collection.getValidPriceBandsFromDom();
      if (!validBands.length) {
        return false;
      }

      var bands = collection.parseFacetList(Shopify.queryParams[collection.PRICE_BANDS_KEY]);
      if (!bands.length) {
        return false;
      }

      var filtered = [];

      bands.forEach(function(band) {
        var sanitized = collection.sanitizePriceBand(band);
        if (sanitized && validBands.indexOf(sanitized) !== -1) {
          filtered.push(sanitized);
        }
      });

      if (filtered.length === bands.length) {
        return false;
      }

      /* Hard refresh / deep link: se o SSR não listou a faixa ativa (bounds
         indisponíveis com filtro), não limpar price_bands nem disparar re-fetch. */
      if (!filtered.length && options.skipClearWhenEmpty) {
        return false;
      }

      if (filtered.length) {
        collection.applyPriceBandsToQuery(filtered);
      } else {
        collection.clearPriceFilterParams();
      }

      return true;
    },

    syncPriceBandsFromResponse: function(data, options) {
      options = options || {};

      if (options.preservePriceBands) {
        collection.syncPriceFilterUI();
        collection.syncSidebarUiState();
        return;
      }

      var html = Array.isArray(data) ? data[0] : data;

      if (!html) {
        return;
      }

      var $incoming = $(html).find('.engoj-collection-sidebar .filter-price .list-price').first();
      /* O sidebar é renderizado duas vezes (desktop e drawer mobile). Atualizar
         só a primeira instância deixaria o drawer com faixas obsoletas, que
         getValidPriceBandsFromDom passaria a aceitar como válidas. */
      var $current = $('.engoj-collection-sidebar .filter-price .list-price');

      if (!$incoming.length || !$current.length) {
        return;
      }

      $current.each(function() {
        $(this).replaceWith($incoming.clone());
      });

      if (collection.sanitizePriceBandsAgainstDom()) {
        collection.fillterClick = true;
        History.replaceState({
          param: Shopify.queryParams
        }, document.title, collection.filterCreateUrl());
        collection.filterGetContent(collection.filterCreateUrl());
        collection.fillterClick = false;
        return;
      }

      collection.syncPriceFilterUI();
      collection.syncSidebarUiState();
    },

    filterMapData: function(data, options) {
        options = options || {};
        var isMultiCategoryMerge = options.multiCategoryMerge === true;
        var currentList = $(".grid-uniform");
        var productList;

        if (isMultiCategoryMerge && Array.isArray(data)) {
          productList = collection.buildMergedProductGrid(data);
        } else {
          productList = $(data).find(".grid-uniform");
        }

        currentList.replaceWith(productList);

        if (!isMultiCategoryMerge) {
          if ($(".pagination").length > 0) {
            $(".pagination").replaceWith($(data).find(".pagination"));
          }

          $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        } else {
          collection.applyMergedPagination(data);
        }

        collection.syncPriceFilterUI();
        collection.syncCategoryFilterUI();
        collection.syncBrandFilterUI();
        collection.syncPriceBandsFromResponse(data, options);
        collection.rewritePaginationLinks();
        collection.filterMapClear();
        collection.syncSidebarUiState();
      	quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
          jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });
      
        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row')

              setTimeout(function(){
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
                //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
                $('.loadmore').eq(0).remove();
                loadmore();
                quickView();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });

                $('.loading.tshopify-popup').removeClass('active');
              },2000)
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();
      
      
        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage });
            return false;
          });
        });

        // Re-executa a ordenação OOS após substituição de conteúdo via AJAX de filtros
        if (window.CollectionOosSort && typeof window.CollectionOosSort.run === 'function') {
          var hasStorefrontFilters = /[?&]filter\.(v|p)\./.test(window.location.search);
          if (!hasStorefrontFilters) {
            // Atualiza o meta com a nova URL (pode ter mudado após filtro)
            var newMeta = $(data).find('#collection-oos-meta');
            if (newMeta.length) {
              var existingMeta = document.getElementById('collection-oos-meta');
              if (existingMeta) {
                existingMeta.textContent = newMeta.text();
              }
            }
            setTimeout(function() {
              window.CollectionOosSort.run();
            }, 100);
          }
        }

    },

    filterCreateUrl: function(baseLink) {
      // traditional: true → arrays viram chaves repetidas (sem []), formato OR da Shopify
      var newQuery = $.param(Shopify.queryParams, true).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      if (newQuery != "")
        return location.pathname + "?" + newQuery;
      return location.pathname;
    },

    filterAjaxClick: function(baseLink, options) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, document.title, newurl);
      collection.filterGetContent(newurl, options);
    },

    paginationAjaxClick: function() {
      if (Shopify.queryParams.page === '1' || Shopify.queryParams.page === 1) {
        delete Shopify.queryParams.page;
      }
      var newurl = collection.filterCreateUrl();
      collection.fillterClick = true;
      collection.isPaginationClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, document.title, newurl);
      collection.filterGetContent(newurl);
    },

    /* Facets são multi-seleção: fechar o drawer a cada aplicação obrigaria o
       usuário a reabri-lo para cada escolha no mobile. Só fecha na paginação
       e em erro, onde a modal de erro precisa ficar visível. */
    closeFilterDrawer: function() {
      hidePopup('.filter-to-left , .js-bg');
    },

    scrollToCollectionTop: function() {
      var $target = $('.collection_prod, .content-page').first();
      var scrollTop = $target.length ? Math.max($target.offset().top - 20, 0) : 0;
      $('html, body').animate({ scrollTop: scrollTop }, 300);
    },

    parseQueryString: function(queryString) {
      var params = {};
      if (!queryString) {
        return params;
      }
      var couples = queryString.split('&');
      for (var i = 0; i < couples.length; i++) {
        var keyValue = couples[i].split('=');
        if (keyValue.length > 1) {
          try {
            var paramKey = decodeURIComponent(keyValue[0]);
            var paramValue = decodeURIComponent(keyValue[1].replace(/\+/g, '%2B'));
            // Accumulate repeated keys (e.g. filter.p.vendor=A&filter.p.vendor=B) into arrays
            if (Object.prototype.hasOwnProperty.call(params, paramKey)) {
              if (!Array.isArray(params[paramKey])) {
                params[paramKey] = [params[paramKey]];
              }
              params[paramKey].push(paramValue);
            } else {
              params[paramKey] = paramValue;
            }
          } catch (err) {
            // Ignore malformed percent-encoding in query params
          }
        }
      }
      return params;
    },

    filterGetContent: function(newurl, options) {
      options = options || {};
      var fetchUrls = collection.getCategoryFetchUrls(newurl);

      if (fetchUrls.length <= 1) {
        var fetchUrl = fetchUrls[0];

        $.ajax({
          type: 'get',
          url: fetchUrl,
          beforeSend: function() {
            showPopup('.loading');
          },

          success: function(data) {
            collection.filterMapData(data, options);
            collection.updateDocumentSeo(data);
            collection.filterMapClear();
            hidePopup('.loading');

            if (collection.isPaginationClick) {
              collection.closeFilterDrawer();
              collection.scrollToCollectionTop();
              collection.isPaginationClick = false;
            }
          },

          error: function(xhr, text) {
            collection.isPaginationClick = false;
            hidePopup('.loading');
            collection.closeFilterDrawer();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            showPopup('.ajax-error-modal');
          }
        });
        return;
      }

      var requests = fetchUrls.map(function(url) {
        return $.ajax({
          type: 'get',
          url: url
        });
      });

      showPopup('.loading');

      $.when.apply($, requests).done(function() {
        var responses = [];

        if (requests.length === 1) {
          responses = [arguments[0]];
        } else {
          for (var i = 0; i < arguments.length; i++) {
            responses.push(arguments[i][0]);
          }
        }

        var mergeOptions = $.extend({}, options, { multiCategoryMerge: true });
        collection.filterMapData(responses, mergeOptions);
        if (responses.length) {
          collection.updateDocumentSeo(responses[0]);
        }
        collection.filterMapClear();
        hidePopup('.loading');

        if (collection.isPaginationClick) {
          collection.closeFilterDrawer();
          collection.scrollToCollectionTop();
          collection.isPaginationClick = false;
        }
      }).fail(function(xhr) {
        collection.isPaginationClick = false;
        hidePopup('.loading');
        collection.closeFilterDrawer();

        if (xhr && xhr.responseText) {
          try {
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          } catch (err) {
            $('.ajax-error-message').text('Unable to load filtered products.');
          }
        }

        showPopup('.ajax-error-modal');
      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        var sanitizedPrice = collection.sanitizePriceBandsAgainstDom({
          skipClearWhenEmpty: true
        });
        if (sanitizedPrice) {
          collection.fillterClick = true;
          History.replaceState({
            param: Shopify.queryParams
          }, document.title, collection.filterCreateUrl());
          collection.fillterClick = false;
        }
        collection.filterMapEvents();
        collection.syncCategoryFilterUI();
        collection.syncBrandFilterUI();
        collection.filterMapClear();
        collection.filterMapClearAll();
        collection.syncLegacyPriceBandsFromQuery();

        if (sanitizedPrice || collection.getSubcollectionHandles().length > 0) {
          collection.filterGetContent(collection.filterCreateUrl());
        }
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Pagination */
    initPagination: function() {
      $("body").delegate('.pagination a.pagination-link[href]', 'click', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var hrefParts = href.split('?');
        var queryString = hrefParts[1] || '';
        Shopify.queryParams = collection.parseQueryString(queryString);

        if (!Shopify.queryParams.subcollection) {
          var pathMatch = hrefParts[0].match(/\/collections\/([^/?#]+)/);
          var parentPath = collection.getCategoryParentPath();
          if (pathMatch && hrefParts[0].replace(/\/$/, '') !== parentPath) {
            var pathHandle = pathMatch[1];
            if (collection.isAllowedCategoryHandle(pathHandle)) {
              Shopify.queryParams.subcollection = pathHandle;
            }
          }
        } else {
          collection.sanitizeSubcollectionParam();
        }

        collection.paginationAjaxClick();
      });
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();     
        if (!$(this).parent().hasClass("active")) {   
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();    
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  

      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);